import { useEffect } from 'react';
import { useGlobalState } from './';

export const useDocumentTitle = (title, objectName = undefined) => {
  const [settings] = useGlobalState('settings');

  useEffect(() => {
    const environment =
      settings.ENVIRONMENT && settings?.ENVIRONMENT !== 'prod'
        ? settings.ENVIRONMENT.toUpperCase() + ' - '
        : '';

    if (title) {
      document.title = environment + title + (objectName ? ' | ' + objectName : '');
    }
  });
};
